import { lazyLoad } from '~/src/shared/utils/loadable';

export const MunicipalityCollaborationKagoshimaIslandCompanyPage = lazyLoad(
  () => import('./index'),
  (module) => module.MunicipalityCollaborationKagoshimaIslandCompany,
);
